import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { Popover, PopoverHeader, PopoverBody } from 'foundations-components/transitional/components/Popover';
import ViewContainerContext from '../../../containers/ViewContainerContext';
import { CLICK_SHARE_RECIPIENT } from '../../../tracking/actions';
import { trackInteraction } from '../../../tracking/tracker';
import { ButtonWithBranding } from '../../ButtonWithBranding';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ViewToolbarShareButton extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      open: false
    };
    this.toggleOpen = () => {
      this.setState(({
        open
      }) => {
        if (!open) {
          trackInteraction(CLICK_SHARE_RECIPIENT);
        }
        return {
          open: !open
        };
      });
    };
    this.renderPopoverContent = () => {
      const {
        shortLink
      } = this.props;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(PopoverHeader, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "view.toolbar.shareThisLink"
            })
          })
        }), /*#__PURE__*/_jsx(PopoverBody, {
          children: /*#__PURE__*/_jsx(CopyInput, {
            value: shortLink,
            paddingBlockEnd: "500"
          })
        })]
      });
    };
  }
  render() {
    const {
      brandingColor,
      hasDownload
    } = this.props;
    const context = this.context;
    return /*#__PURE__*/_jsx(Popover, {
      open: this.state.open,
      closeOnOutsideClick: true,
      onOpenChange: evt => this.setState({
        open: evt.target.value
      }),
      placement: "bottom",
      Content: this.renderPopoverContent,
      inlineSize: "350px",
      children: /*#__PURE__*/_jsx(ButtonWithBranding, {
        brandingColor: brandingColor,
        onClick: this.toggleOpen,
        disabled: context.isPreview,
        "aria-disabled": context.isPreview,
        "aria-label": I18n.text('a11y.shareButton'),
        marginInlineEnd: hasDownload ? '200' : '800',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.toolbar.share"
        })
      })
    });
  }
}
ViewToolbarShareButton.contextType = ViewContainerContext;